import {
  type InstrumentType,
  type OrderSide,
  type TradeDirection,
} from "#/types/trade";

export const toDirection = (input: OrderSide | boolean): TradeDirection => {
  if (typeof input === "boolean") {
    return input ? "buy" : "sell";
  }

  return input === "ask" ? "buy" : "sell";
};

export const toSide = (input: TradeDirection | boolean): OrderSide => {
  return input === "buy" || input === true ? "ask" : "bid";
};

export const toTradeDirection = (direction: TradeDirection): string => {
  return direction === "buy" ? "bought" : "sold";
};

export const isBuy = (direction: TradeDirection): boolean => {
  return direction === "buy";
};

export const toInstrumentType = (isOption: boolean): InstrumentType => {
  return isOption ? "options" : "perps";
};

export const flipDirection = (direction: TradeDirection): TradeDirection => {
  return isBuy(direction) ? "sell" : "buy";
};

export const getDirectionIndex = (direction: TradeDirection): number => {
  return isBuy(direction) ? 0 : 1;
};
